"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpedeAbilityHandler = exports.ImpedeActorAbilityFactory = exports.ImpedeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EffectType_1 = require("../../core/effects/EffectType");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class ImpedeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Impede;
        this.__typeName = "Impede";
    }
}
exports.ImpedeAbilityArgs = ImpedeAbilityArgs;
let ImpedeActorAbilityFactory = class ImpedeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Impede", "AllEnemies", 0);
    }
};
ImpedeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Impede")
], ImpedeActorAbilityFactory);
exports.ImpedeActorAbilityFactory = ImpedeActorAbilityFactory;
let ImpedeAbilityHandler = class ImpedeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(ability.invokerId, "feet"), "OverlappingTimeCircles"));
                container.applyProjectiles({
                    sequence: sequence.pushSequence("parallel"),
                    projectiles: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                        .filter(other => container.hasEffectOfType(other, EffectType_1.EffectType.Withering))
                        .map(targetId => ({
                        creatorId: ability.invokerId,
                        targetId,
                        path: "line",
                        type: "PurpleArcaneMissle",
                        jitter: 0
                    })),
                    onProjectile: (sequence, projectile) => {
                        const wp = container.getEffectsOfType(projectile.targetId, EffectType_1.EffectType.Withering)
                            .map(eid => container.getEffect(eid))
                            .reduce((sum, next) => sum + next.args.power, 0);
                        const multiplier = container.hasEffectOfType(projectile.targetId, EffectType_1.EffectType.LikeABoss) ? .1
                            : .5;
                        const tm = Math.round(wp * multiplier);
                        container.applyBuffs({
                            sequence: sequence.pushSequence("parallel"),
                            creatorId: ability.invokerId,
                            targetId: projectile.targetId,
                            effects: [
                                {
                                    duration: Duration_1.Duration.Instant,
                                    effect: new core_1.TurnMeterDecreaseEffectArgs(tm, true)
                                },
                                {
                                    duration: Duration_1.Duration.Instant,
                                    effect: new core_1.RemoveEffectsOfTypeEffectArgs(EffectType_1.EffectType.Withering, false)
                                },
                                {
                                    duration: Duration_1.Duration.Turns(3),
                                    effect: new core_1.HasteEffectArgs(2)
                                }
                            ]
                        });
                    }
                });
            }
        });
    }
};
ImpedeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Impede)
], ImpedeAbilityHandler);
exports.ImpedeAbilityHandler = ImpedeAbilityHandler;
